{
  "PAYMENT_DECLINE_REASON": {
    "AUTHENTICATION_REQUIRED": {
      "DESCRIPTION": "The card was declined as the transaction requires authentication.",
      "NEXT_STEPS": "The customer should try again and authenticate their card when prompted during the transaction."
    },
    "APPROVE_WITH_ID": {
      "DESCRIPTION": "The payment cannot be authorized.",
      "NEXT_STEPS": "The payment should be attempted again. If it still cannot be processed, the customer needs to contact their card issuer."
    },
    "CARD_NOT_SUPPORTED": {
      "DESCRIPTION": "The card does not support the specified currency.",
      "NEXT_STEPS": "The customer needs to check with the issuer whether the card can be used for the type of currency specified."
    },
    "DUPLICATE_TRANSACTION": {
      "DESCRIPTION": "A transaction with identical amount and credit card information was submitted very recently.",
      "NEXT_STEPS": "Check to see if a recent payment already exists."
    },
    "EXPIRED_CARD": {
      "DESCRIPTION": "The card has expired.",
      "NEXT_STEPS": "The customer should use another card."
    },
    "FRAUDULENT": {
      "DESCRIPTION": "The payment has been declined as the payment facilitator suspects it is fraudulent.",
      "NEXT_STEPS": "Do not report more detailed information to your customer. Instead, present it as you would a generic decline."
    },
    "INCORRECT_NUMBER": {
      "DESCRIPTION": "The card number is incorrect.",
      "NEXT_STEPS": "The customer should try again using the correct card number."
    },
    "INCORRECT_CVC": {
      "DESCRIPTION": "The CVC number is incorrect.",
      "NEXT_STEPS": "The customer should try again using the correct CVC."
    },
    "INCORRECT_PIN": {
      "DESCRIPTION": "The PIN entered is incorrect. This decline code only applies to payments made with a card reader.",
      "NEXT_STEPS": "The customer should try again using the correct PIN."
    },
    "INCORRECT_ZIP": {
      "DESCRIPTION": "The ZIP/postal code is incorrect.",
      "NEXT_STEPS": "The customer should try again using the correct ZIP/postal code."
    },
    "INSUFFICIENT_FUNDS": {
      "DESCRIPTION": "The card has insufficient funds to complete the purchase.",
      "NEXT_STEPS": "The customer should use an alternative payment method."
    },
    "INVALID_ACCOUNT": {
      "DESCRIPTION": "The card, or account the card is connected to, is invalid.",
      "NEXT_STEPS": "The customer needs to contact their card issuer for more information."
    },
    "INVALID_AMOUNT": {
      "DESCRIPTION": "The payment amount is invalid, or exceeds the amount that is allowed.",
      "NEXT_STEPS": "If the amount appears to be correct, the customer needs to check with their card issuer that they can make purchases of that amount."
    },
    "INVALID_CVC": {
      "DESCRIPTION": "The CVC number is incorrect.",
      "NEXT_STEPS": "The customer should try again using the correct CVC."
    },
    "INVALID_EXPIRY_YEAR": {
      "DESCRIPTION": "The expiration date is invalid.",
      "NEXT_STEPS": "The customer should try again using the correct expiration date."
    },
    "INVALID_NUMBER": {
      "DESCRIPTION": "The card number is invalid.",
      "NEXT_STEPS": "The customer should try again using the correct card number."
    },
    "INVALID_PIN": {
      "DESCRIPTION": "The PIN entered is incorrect. This decline code only applies to payments made with a card reader.",
      "NEXT_STEPS": "The customer should try again using the correct PIN."
    },
    "ISSUER_NOT_AVAILABLE": {
      "DESCRIPTION": "The card issuer could not be reached, so the payment could not be authorized.",
      "NEXT_STEPS": "The payment should be attempted again. If it still cannot be processed, the customer needs to contact their card issuer."
    },
    "LOST_CARD": {
      "DESCRIPTION": "The payment has been declined because the card is reported lost.",
      "NEXT_STEPS": "The specific reason for the decline should not be reported to the customer. Instead, it needs to be presented as a generic decline."
    },
    "MERCHANT_BLACKLIST": {
      "DESCRIPTION": "The payment has been declined because it matches a value on the payment facilitator's block list.",
      "NEXT_STEPS": "Do not report more detailed information to your customer. Instead, present it as you would a generic decline."
    },
    "OFFLINE_PIN_REQUIRED": {
      "DESCRIPTION": "The card has been declined as it requires a PIN.",
      "NEXT_STEPS": "The customer should try again by inserting their card and entering a PIN."
    },
    "ONLINE_OR_OFFLINE_PIN_REQUIRED": {
      "DESCRIPTION": "The card has been declined as it requires a PIN.",
      "NEXT_STEPS": "If the card reader supports Online PIN, the customer should be prompted for a PIN without a new transaction being created. If the card reader does not support Online PIN, the customer should try again by inserting their card and entering a PIN."
    },
    "PICKUP_CARD": {
      "DESCRIPTION": "The card cannot be used to make this payment (it is possible it has been reported lost or stolen).",
      "NEXT_STEPS": "The customer should contact their card issuer for more information."
    },
    "PIN_TRY_EXCEEDED": {
      "DESCRIPTION": "The allowable number of PIN tries has been exceeded.",
      "NEXT_STEPS": "The customer must use another card or method of payment"
    },
    "PROCESSING_ERROR": {
      "DESCRIPTION": "An error occurred while processing the card.",
      "NEXT_STEPS": "The payment should be attempted again. If it still cannot be processed, try again later."
    },
    "REENTER_TRANSACTION": {
      "DESCRIPTION": "The payment could not be processed by the issuer for an unknown reason.",
      "NEXT_STEPS": "The payment should be attempted again. If it still cannot be processed, the customer needs to contact their card issuer."
    },
    "RESTRICTED_CARD": {
      "DESCRIPTION": "The card cannot be used to make this payment (it is possible it has been reported lost or stolen).",
      "NEXT_STEPS": "The customer should contact their card issuer for more information."
    },
    "STOLEN_CARD": {
      "DESCRIPTION": "The payment has been declined because the card is reported stolen.",
      "NEXT_STEPS": "The specific reason for the decline should not be reported to the customer. Instead, it needs to be presented as a generic decline."
    },
    "TESTMODE_DECLINE": {
      "DESCRIPTION": "A payment facilitator test card number was used.",
      "NEXT_STEPS": "A genuine card must be used to make a payment."
    },
    "TRY_AGAIN_LATER": {
      "DESCRIPTION": "The card has been declined for an unknown reason.",
      "NEXT_STEPS": "Ask the customer to attempt the payment again. If subsequent payments are declined, the customer should contact their card issuer for more information."
    },
    "WITHDRAWAL_COUNT_LIMIT_EXCEEDED": {
      "DESCRIPTION": "The customer has exceeded the balance or credit limit available on their card.",
      "NEXT_STEPS": "The customer should use an alternative payment method."
    },
    "UNKNOWN_CONTACT_ISSUER": {
      "DESCRIPTION": "The card has been declined for an unknown reason.",
      "NEXT_STEPS": "The customer needs to contact their card issuer for more information."
    },
    "CARD_VELOCITY_EXCEEDED": {
      "DESCRIPTION": "The customer has exceeded the balance, credit limit, or transaction amount limit available on their card.",
      "NEXT_STEPS": "The customer needs to contact their card issuer for more information."
    }
  }
}
